import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateCustomer } from 'slice/customerSlice';
import AdminTable from 'common/AdminTable';
import { getRequest } from 'apis/ApiInstence';
import { useParams } from 'react-router-dom';

const ListPlay = () => {
    const dispatch = useDispatch()
    const { id } = useParams();
    const [cartData, setCardData] = useState([])
    const [showModal, setShowModal] = useState(false);
    const [isToday, setIsToday] = useState(true)
    const [currentProduct, setCurrentProduct] = useState(null);

    const getData = async () => {
        const data = await getRequest(`customer/bidhistory/${id}?fil=${isToday ? 'today' : ''}`);
        setCardData(data?.data?.bids)
    }
    useEffect(() => {
        getData()
    }, [isToday])

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentProduct(null);
    };

    // Handle saving the edited product
    const handleSave = () => {
        const formData = new FormData();
        formData.append('id', currentProduct.id);
        formData.append('status', currentProduct.status);
        formData.append('wallet', currentProduct.wallet);
        // Dispatch updateProduct with the formData
        dispatch(updateCustomer({ id: currentProduct.mobile, data: currentProduct }));
        handleCloseModal(); // Close modal after saving
    };

    // Table Headers
    const tableHeaders = [
        {
            Header: 'Game Name',
            accessor: 'product.name',
            Cell: ({ row }) => {
                const capitalize = (str) =>
                    str.replace(/\b\w/g, char => char.toUpperCase());

                return <>{row?.original?.product?.name ? capitalize(row.original.product.name) : ''}</>;
            }
        },
        {
            Header: 'Digit Type',
            accessor: 'digit_label',
        },

        {
            Header: 'Amount',
            accessor: 'amount',
        },
        {
            Header: 'Select Number',
            accessor: 'selected_number'
        },
        {
            Header: 'Select Number',
            accessor: 'createdAt'
        }
    ];

    return (
        <>
            <div className='container-fluid mt-5'>
                <div className="mainheadig mx-4 d-flex align-items-center">
                    <h4 className="font-weight-bold">Bid List</h4>
                    <button className="ml-auto btn btn-primary mr-4" onClick={() => setIsToday(!isToday)}>Today</button>
                </div>
                {cartData?.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData} />
                ) : <tr ><p className='text-center'>No Data Found </p></tr>}

                {showModal && currentProduct && (
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="editModalLabel">View Customer</h5>
                                    <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="form-group">
                                            <label htmlFor="status">Action</label>
                                            <select className='form-control' value={currentProduct?.is_active} onChange={(e) => setCurrentProduct({ ...currentProduct, status: e.target.value })}>
                                                <option value={1}>Active</option>
                                                <option value={0}>Inactive</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="productPrice">Wallet</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="productPrice"
                                                value={currentProduct?.wallet}
                                                onChange={(e) => setCurrentProduct({ ...currentProduct, wallet: e.target.value })}
                                            />
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                                    <button type="button" className="btn btn-primary" onClick={handleSave}>Save changes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div >
        </>
    )
}

export default ListPlay;
